import styled from "styled-components";

import { TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

// Keep at least ~4 characters of the main domain visible before the ellipsis.
const MIN_VISIBLE_DOMAIN_WIDTH = "5ch";

export const StyledDomain = styled(TruncatedTextWithTooltip)`
    min-width: ${MIN_VISIBLE_DOMAIN_WIDTH};
`;

export const StyledCount = styled(Text)`
    flex-shrink: 0;
    white-space: nowrap;
`;
